import {
  FormControl,
  FormLabel,
  FormControlLabel,
  FormHelperText,
  Radio,
  RadioGroup,
} from "@mui/material";

import { Controller } from "react-hook-form"

import { useFormContext } from 'react-hook-form';

const FormRadioGroup = ({ name, list, label = undefined, required, rules = {} }) => {
  const { control, formState: { errors } } = useFormContext();

  const hasError = (name in errors) ? true : false;
  const errorMessage = (name in errors) ? errors[name]?.message : '';

  const requiredDefaultRule = required ? { required: { value: true, message: "This field is required" } } : {};
  rules = { ...requiredDefaultRule, ...rules };

  return (
    <Controller
      render={({ field: { onChange, value, onBlur } }) => {
        value = value || [];
        const handleChange = (e) => {
          onChange(e.target.value);
        };

        return (
          <>
            <FormControl fullWidth error={errors[name] ? true : false}>
              {label && <FormLabel component="legend">{label}</FormLabel>}
              {hasError && <FormHelperText error={hasError}>{String(errorMessage)}</FormHelperText>}
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                name={name}
                value={value}
                onChange={handleChange}
              >
                {list.map((cur) => (<FormControlLabel key={'check-' + cur.value} control={<Radio />} value={cur.value} label={cur.label ?? cur.value} />))}
              </RadioGroup>
            </FormControl>
          </>
        );
      }}
      name={name}
      control={control}
      rules={rules}
    />
  );
}
export default FormRadioGroup;
